// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"styles_textWrapper__z9lpg","char":"styles_char__1RZal"};